import React, { useEffect, useState } from "react";
import { Box, Grid2 } from "@mui/material";
import SubTabs from "components/SubTabs";
import subTabsItems from "components/subTabs-items";
import ClaimsKPI from "./ClaimsKPI";
import TotalClaimValue from "./TotalClaimValue";
import OpenClaimsByContractor from "./OpenClaimsByContractor";
import OpenClaims from "./OpenClaims";
import ImpactChangeOrders from "./ImpactChangeOrders";
import ChangeOrderByContractor from "./ChangeOrderByContractor";
import ClaimsChangeOrderList from "./ClaimsChangeOrderList";
import ImpactOfClaims from "./ImpactOfClaims";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

const ClaimAndChangeOrder = () => {

    const { hasPermission } = useCheckMenuPermission();
    const [value, setValue] = useState(null);

    useEffect(() => {
        const storedIndex = localStorage.getItem("claims-and-changeorderTabIndex");
        if (storedIndex !== null) {
            setValue(Number(storedIndex));
        } else {
            const firstPermittedTab = subTabsItems?.claimAndChangeOrder?.find(item =>
                hasPermission([item?.permissionKey])
            );
            if (firstPermittedTab != undefined) {
                localStorage.setItem("claims-and-changeorderTabIndex", firstPermittedTab.index ?? 0);
                setValue(firstPermittedTab?.index ?? 0)
            }
        }
    }, [hasPermission, subTabsItems]);

    const handleChange = (newIndex) => {
        setValue(newIndex);
        localStorage.setItem("claims-and-changeorderTabIndex", newIndex);
    };
    // };
    return (
        <>
            <SubTabs subTabs={subTabsItems?.claimAndChangeOrder} selectedTab={handleChange} selectedIndex={value} />
            <CustomTabPanel value={value} index={0}>
                <Grid2 container spacing={2}>
                    <Grid2 size={{ xs: 12, md: 12 }}>
                        <ClaimsKPI />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 4.5 }}>
                        <TotalClaimValue />
                        <OpenClaims />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 7.5 }}>
                        <OpenClaimsByContractor />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 4.5 }}>
                        <ImpactOfClaims />
                        <ImpactChangeOrders />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 7.5 }}>
                        <ChangeOrderByContractor />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 12 }}>
                        <ClaimsChangeOrderList />
                    </Grid2>
                </Grid2>
            </CustomTabPanel>

        </>
    );
};

export default ClaimAndChangeOrder;